export const LISTING_TYPE_HUMAN_NAME_MAP_TITLE = {
  JOB: getText('Job'),
  INTERNSHIP: getText('Internship'),
  VOLOP: getText('Volunteer Opportunity'),
  ORG: getText('Organization'),
  GROUP: getText('Mutual Aid Group'),
  IDEALIST_DAY_EVENT: getText('Idealist Day'),
  GRAD_PROGRAM: getText('Graduate Program'),
  IDEALIST_DAYS_MAP_PIN: getText('Action'),
  USER: getText('User'),
};

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getListingTypeHumanNameTitle = (listing: any) =>
  LISTING_TYPE_HUMAN_NAME_MAP_TITLE[listing.type];
